import { OrderStatusEnum } from '@ztechapps/common.contract'

const SHIPPED_STATUSES: OrderStatusEnum[] = [
  OrderStatusEnum.InTransit,
  OrderStatusEnum.Delivered,
  OrderStatusEnum.Cancelled,
]

export const getShippingDateLabel = (status?: OrderStatusEnum | string): string =>
  SHIPPED_STATUSES.includes(status as OrderStatusEnum) ? 'Shipped Date' : 'Est. Shipping Date'
